/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IncludedInInsuranceClaim/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function IncludedInInsuranceClaim({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/Content/Content/Charge/ActionsAction/Edit/Content/IncludedInInsuranceClaim",
  onChange
  
}) {
let editIsIncludedInInsuranceClaimValueData = fromData.useDataValue({ viewPath,
context: 'edit',
path: 'is_included_in_insurance_claim',
})
let editIsIncludedInInsuranceClaimChangeData = fromData.useDataChange({ viewPath,
context: 'edit',
path: 'is_included_in_insurance_claim',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="edit.is_included_in_insurance_claim"
 value={editIsIncludedInInsuranceClaimValueData}
 onChange={editIsIncludedInInsuranceClaimChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Include in insurance claim"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}